import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=4b2f817c&"
import script from "./participants.vue?vue&type=script&lang=js&"
export * from "./participants.vue?vue&type=script&lang=js&"
import style0 from "./participants.vue?vue&type=style&index=0&id=4b2f817c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports